import { render } from "./cart-drawer-overlay.vue?vue&type=template&id=2491bdbf"
import script from "./cart-drawer-overlay.vue?vue&type=script&lang=js"
export * from "./cart-drawer-overlay.vue?vue&type=script&lang=js"

import "./cart-drawer-overlay.vue?vue&type=style&index=0&id=2491bdbf&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__